// extracted by mini-css-extract-plugin
export var tkMyriadProSemiCondensed = "BlogPost--tk-myriad-pro-semi-condensed--L7dEV";
export var wpPosts = "BlogPost--wpPosts--wSRRa";
export var wpPosts__button = "BlogPost--wpPosts__button--NhTZR";
export var wpPosts__content = "BlogPost--wpPosts__content--TCuHl";
export var wpPosts__cta = "BlogPost--wpPosts__cta--QhatU";
export var wpPosts__post = "BlogPost--wpPosts__post--J10Vm";